// @flow

type PossibleReturn = string | Function; //  | ComponentType<*>

type Argument = {|
  value: PossibleReturn,
  pattern: string,
  description: string,
  hideInsertButton?: boolean,
  macro: string,
|};

type RF = (template: PossibleReturn, args: Argument) => Array<PossibleReturn>;
export const replaceTemplate: RF = (template, { pattern, value }) => {
  // if the template is a function, we dont need to look for the pattern
  // we can return it so it will be called later
  if (typeof template === 'function') {
    return [template];
  }

  const regex = new RegExp(pattern, 'gi');
  // split the given string to find a replacement
  return template.split(regex).map(str => {
    // all pieces that are not the pattern are returned
    if (!regex.test(str)) {
      return str;
    }
    // the found pattern is being replaced with the given value
    return value;
  });
};

type F = (
  template: string,
  args: Array<Argument>,
) => Array<PossibleReturn>;
const parseTemplate: F = (template, args) => (
  // args is a list of possible replacements
  // for every possible replacement, loop over the template,
  // which is converted to a array of strings and functions
  args.reduce((list, arg) => (
    // for every replacement, call replaceTemplate
    // which returns an array of more strings or functions
    // merge these new items into the list
    list.reduce((arr, str) => (
      arr.concat(replaceTemplate(str, arg))),
    [])
  ),
  [template])
);

export default parseTemplate;
